<template>
  <div>
    <van-nav-bar title="抬头信息"/>
    <van-card
      desc="描述信息"
      title=""
      thumb="https://img.yzcdn.cn/vant/ipad.jpeg"
    >
      <div slot="desc" style="font-size:0.9rem">
        <div style="margin-top:1rem;">
          我的昵称
        </div>
        <div style="margin-top:0.6rem;">
          {{userName}}
        </div>
      </div>
    </van-card>
    <van-row class="user-links" v-show="this.$appConfig.roleState">
      <van-col span="6">
        <van-icon name="bag-o" @click="toOrderRecord()"/>
        全部订单
      </van-col>
      <van-col span="6">
        <van-icon name="pending-payment" @click="toBillinRecord()"/>
        已开票
      </van-col>
      <van-col span="6">
        <van-icon name="tosend" @click="toPendingPayment()"/>
        待付款
      </van-col>
      <van-col span="6">
        <van-icon name="logistics" @click="toReInvoicing()"/>
        已付款
      </van-col>
    </van-row>
    <!-- <van-cell-group>
      <van-cell title="数电登录" is-link @click="sdLogin()"/>
    </van-cell-group> -->

    <van-cell-group>
      <van-cell title="退出登录" is-link @click="returnlogin()"/>
    </van-cell-group>

  </div>
</template>

<script>
import {Card, Cell, CellGroup, Col, Dialog, Icon, Row, Tabbar, TabbarItem, Toast} from 'vant';

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Card.name]: Card
  },
  data() {
    return {
      userName:'',
      memPicture: require("./../../assets/img/userBaner.jpg"),
    }
  },
  created() {
  
     this.userName=localStorage.getItem("sanitationUsername");

  },
  methods: {
    toBillinRecord(){   //已开票查询
      this.$router.push({path: '/order', query: {status:'3'}})
    },
    toReInvoicing(){   //已付款查询
      this.$router.push({path: '/order', query: {status:'1'}})
    },
    toPendingPayment(){  //等待付款
      this.$router.push({path: '/order', query: {status:'0'}})
    },
    toOrderRecord(){   //全部订单
      this.$router.push({path: '/order', query: {status:'-1'}})
    },
    sorry() {
      Toast('敬请期待')
    },
    toPhone(item) {
       window.location.href = 'tel://' + item;
    },

    sdLogin(){
      this.$router.push({path: '/sddl'})
    },
    returnlogin(){
      // localStorage.removeItem("sanitationAccessToken")
      // localStorage.removeItem("sanitationUsername")
      // localStorage.removeItem("role")
      this.$router.push({path: '/login'})
    }
  }
}
</script>

<style lang="less">
.user {
  &-poster {
    width: 100%;
    display: block;
  }

  &-group {
    margin-bottom: 15px;
  }

  &-links {
    padding: 15px 0;
    font-size: 12px;
    text-align: center;
    background-color: #fff;

    .van-icon {
      display: block;
      font-size: 24px;
    }
  }
}
</style>
